module.exports = __webpack_public_path__ + "img/yop.9fcf39dc.png";